/**
 * Tabs
 */
export enum SettingsTabs {
    menu = 'menu',
    general = 'general',
    identity = 'identity',
    account = 'account',
    security = 'security',
    sessions = 'sessions',
}
